import { marked } from "marked";

export const TEXT = marked(`
In the original game RouteWord, several people liked to submit strings that made interesting shapes.  If you want to add something here, use the "Create" feature and just make a note in the clue field that starts with PLAYGROUND and I'll add it to the list

`);
